import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import useLoader from '../../contexts/LoaderContext';
import LocaleAndCurrency from '../../constants/localeMap'
import LocaleAndCurrencyDLI from '../../constants/localeMapDLI'
import { useCart } from "../../services/cartService";
import Spinner from '../Spinner/Spinner';

const DLI_STORE = 'dli';
const ACADEMY_STORE = 'academy';

const GeoRedirect = () => {
    const queryParams = new URLSearchParams(useLocation().search);
    const { createCart } = useCart();
    const [env, setEnv] = useState('stg');
    const [store, setStore] = useState('');
    const [queueItLoaded, setQueueItLoaded] = useState(false);
    const { isBodyLoading } = useLoader();
    const country = queryParams.get("country");
    // pid param format: "productID_variationID_quantity,productID_variationID_quantity,..."
    const pidParam = queryParams.get("pid");


    useEffect(() => {
        const host = window.location.hostname;
        const pathname = window.location.pathname;
        if (host !== "marketplace.nvidia.com") {
            setEnv(host.split(".")[0].split("-")[0] + '-')
        }
        if (pathname.includes("buy")) {
            setStore(pathname.split("/")[1]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        if (country && pidParam && queueItLoaded) {
            const localeCurMap = store === DLI_STORE ? LocaleAndCurrencyDLI : LocaleAndCurrency;
            const { locale, currency } = localeCurMap[country] || localeCurMap['US'];
            const headerObj = {
                "accept": "application/json, text/javascript, */*; q=0.01",
                "content-type": "application/json",
                "partner": "true",
            }
            localStorage.setItem('store', store);

            // Base cart structure
            try {
                if (store === ACADEMY_STORE) {
                    const products = pidParam
                        ? pidParam.split(',').map(item => {
                            const [productId, variationId, quantity] = item.split('_');
                            return {
                                productId: variationId ? String(productId) + '_' + String(variationId) : String(productId),
                                quantity: Number(quantity)
                            };
                        })
                        : [];
                    const requestBody = {
                        cart: {
                            products: products,
                            isDigital: true,
                            currency,
                            locale
                        }
                    };

                    createCart(requestBody, headerObj, () => {
                        window.location.href = 'https://' + window.location.host + '/' + locale.replace('_', '-').toLowerCase() + '/software/cart/'
                    }, (error) => {
                        console.error('Error adding to cart:', error);
                    });
                } else if (store === DLI_STORE) {
                    const baseCart = {
                        cart: {
                            products: [{ productId: pidParam, quantity: 1 }],
                            isDigital: true,
                            currency,
                            locale
                        }
                    };
                    createCart(baseCart, headerObj, () => {
                        window.location.href = 'https://' + window.location.host + '/' + locale.replace('_', '-').toLowerCase() + '/software/cart/'
                    }, (error) => {
                        console.error('Error adding to cart:', error);
                    });
                } else {
                    throw new Error('Invalid request');
                }
            } catch (error) {
                console.error('Error redirecting to cart:', error);
            }

        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [country, pidParam, env, queueItLoaded])

    useEffect(() => {
        let interceptDomain = "api.store.nvidia.com";
        let domain_prefix = window.location.host.split(".")[0];
        if (domain_prefix !== "marketplace" && domain_prefix !== "dev") {
            interceptDomain = domain_prefix.split("-")[0] + "-" + interceptDomain;
        }

        let scriptsLoaded = 0;
        const totalScripts = 2;

        const markScriptLoaded = () => {
            scriptsLoaded++;
            if (scriptsLoaded === totalScripts) {
                setQueueItLoaded(true);
            }
        };

        // Load queueit client script
        let queueit_client = document.createElement('script');
        queueit_client['src'] = '//static.queue-it.net/script/queueclient.min.js';
        queueit_client.type = 'text/javascript';
        queueit_client.onload = markScriptLoaded;
        queueit_client.onerror = () => {
            console.error('Failed to load QueueIt client script');
            markScriptLoaded(); // Continue anyway
        };
        document.getElementsByTagName('head')[0].appendChild(queueit_client);

        // Load queueit config script
        let queueit_config = document.createElement('script');
        queueit_config.src = '//static.queue-it.net/script/queueconfigloader.min.js';
        queueit_config.type = 'text/javascript';
        queueit_config.setAttribute("data-queueit-c", "nvidia");
        queueit_config.setAttribute('data-queueit-intercept-domain', interceptDomain);
        queueit_config.setAttribute('data-queueit-intercept', "true");
        queueit_config.onload = markScriptLoaded;
        queueit_config.onerror = () => {
            console.error('Failed to load QueueIt config script');
            markScriptLoaded(); // Continue anyway
        };
        document.getElementsByTagName('head')[0].appendChild(queueit_config);

        // Fallback timeout in case scripts don't load within reasonable time
        const fallbackTimeout = setTimeout(() => {
            if (!queueItLoaded) {
                console.warn('QueueIt scripts taking too long to load, proceeding anyway');
                setQueueItLoaded(true);
            }
        }, 5000); // 5 second fallback

        // Cleanup timeout if scripts load successfully
        return () => clearTimeout(fallbackTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className={isBodyLoading ? "loading App" : "App"}><Spinner /></div>
    );

}
export default GeoRedirect;